var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.345 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h229.517v335.449z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.277h-335.8c.233 0 .465.034.689.104l53.386 16.312c2.223.679 2.222 3.828-.002 4.505l-46.335 14.108c-2.225.678-2.226 3.826-.002 4.505l46.34 14.162c2.223.679 2.222 3.828-.002 4.504l-46.336 14.109c-2.225.678-2.226 3.826-.002 4.505l46.34 14.162c2.223.679 2.222 3.828-.002 4.504l-46.322 14.103c-2.226.679-2.226 3.829 0 4.506l46.322 14.103c2.225.678 2.226 3.826.002 4.505l-46.34 14.162c-2.223.68-2.222 3.829.002 4.505l46.336 14.108c2.225.676 2.226 3.826.002 4.505l-46.34 14.162c-2.223.68-2.222 3.828.002 4.505l46.336 14.108c2.225.676 2.226 3.826.002 4.504l-46.34 14.162c-2.223.68-2.222 3.829.002 4.505l46.335 14.109c2.225.676 2.226 3.826.002 4.504l-46.339 14.161c-2.223.68-2.222 3.828.002 4.505l46.322 14.105c2.226.676 2.226 3.828 0 4.504l-46.322 14.105c-2.225.676-2.226 3.826-.002 4.504l46.34 14.162c2.223.679 2.222 3.828-.002 4.504l-53.386 16.255a2.347 2.347 0 0 1-.686.103h335.799a8.829 8.829 0 0 0 8.828-8.828V97.104a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#873250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.dc9520d15104b8fcb1944510293da19b.svg";
export { ForwardRef as ReactComponent };